<app-admin-page-shell
  titleKey="app.admin.identity.integrationReview.title"
  subtitleKey="app.admin.identity.integrationReview.subtitle"
  [panelled]="false"
>
  <div class="integration-review">
    @if (pageError()) {
      <app-info-banner
        class="integration-review__banner"
        variant="warning"
        [title]="'app.admin.identity.integrationReview.actionErrorTitle'"
        [message]="pageError()!"
        [ariaLabel]="'app.admin.identity.integrationReview.actionErrorAria'"
        [translateTitle]="true"
        [translateMessage]="false"
        [translateAriaLabel]="true"
      />
    }

    @if (loading()) {
      <p class="integration-review__loading">
        {{ 'app.admin.identity.integrationReview.loading' | translate }}
      </p>
    } @else if (loadError()) {
      <app-info-banner
        class="integration-review__banner"
        variant="warning"
        [title]="'app.admin.identity.integrationReview.loadErrorTitle'"
        [message]="'app.admin.identity.integrationReview.loadErrorHint'"
        [ariaLabel]="'app.admin.identity.integrationReview.loadErrorAria'"
        [translateTitle]="true"
        [translateMessage]="true"
        [translateAriaLabel]="true"
        iconUrl="/public/svgs/refresh.svg"
      />
    } @else if (requests().length === 0) {
      <p class="integration-review__empty">
        {{ 'app.admin.identity.integrationReview.empty' | translate }}
      </p>
    } @else {
      <ul class="review-list">
        @for (request of requests(); track request.id) {
          <li class="review-card">
            <header class="review-card__header">
              <div>
                <h2>{{ request.appName }}</h2>
                <p class="review-card__meta">
                  <span>{{ request.requestedClientId }}</span>
                  <span>{{ request.providerType }}</span>
                  <span>{{ request.environment }}</span>
                </p>
              </div>
            </header>

            <dl class="review-card__details">
              <div>
                <dt>{{ 'app.admin.identity.integrationReview.redirectUris' | translate }}</dt>
                <dd>
                  <ul>
                    @for (uri of request.redirectUris ?? []; track uri) {
                      <li>{{ uri }}</li>
                    }
                  </ul>
                </dd>
              </div>
              <div>
                <dt>{{ 'app.admin.identity.integrationReview.scopes' | translate }}</dt>
                <dd>
                  <ul>
                    @for (scopeId of request.scopeIds ?? []; track scopeId) {
                      <li>{{ scopeLabel(scopeId) }}</li>
                    }
                  </ul>
                </dd>
              </div>
            </dl>

            <label class="review-card__notes">
              <span>{{ 'app.admin.identity.integrationReview.notesLabel' | translate }}</span>
              <textarea
                rows="3"
                [value]="notesFor(request.id)"
                (input)="updateNotes(request.id ?? '', $any($event.target).value)"
                [placeholder]="'app.admin.identity.integrationReview.notesPlaceholder' | translate"
              ></textarea>
            </label>

            <div class="review-card__actions">
              <app-cta-button
                size="small"
                [disabled]="isActing(request.id)"
                (clicked)="approve(request)"
              >
                <span cta-label>
                  {{ 'app.admin.identity.integrationReview.approve' | translate }}
                </span>
              </app-cta-button>
              <app-cta-button
                size="small"
                variant="secondary"
                [disabled]="isActing(request.id)"
                (clicked)="requestInfo(request)"
              >
                <span cta-label>
                  {{ 'app.admin.identity.integrationReview.needsInfo' | translate }}
                </span>
              </app-cta-button>
              <app-cta-button
                size="small"
                variant="secondary"
                [disabled]="isActing(request.id)"
                (clicked)="reject(request)"
              >
                <span cta-label>
                  {{ 'app.admin.identity.integrationReview.reject' | translate }}
                </span>
              </app-cta-button>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</app-admin-page-shell>
